import NavBar from "../../Component/NavBar/NavBar";
import {BiSolidUserDetail} from "react-icons/bi";
import React, {useEffect, useState} from "react";
import Loading from "../../Component/Loading/Loading";
import {useNavigate} from "react-router-dom";
import apiRequests from "../../Component/axios/config/config";
import {IoIosAddCircleOutline} from "react-icons/io";

export default function Invoice() {
    const navigate = useNavigate();
    const [invoice, setInvoice] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    function apiGetUser() {
        setLoading(true);
        const params = {
            page: page,
            limit: 10,
        };

        if (searchQuery) {
            params.search = searchQuery;
        }

        apiRequests
            .get(`/api/invoice/get-all-admin`,{params})
            .then((response) => {
                setInvoice(response.data.data.docs);
                setTotalPages(response.data.data.totalPages || 1); // سرورت باید totalPages برگردونه
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
            })
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        apiGetUser();
    }, [page, searchQuery]);

    return (
        <div className="p-6">
            <div className="text-3xl font-bold text-gray-800 mb-6">
                Invoice List
            </div>

            <NavBar
                item={[
                    {
                        icon: <BiSolidUserDetail style={{fontSize: "22px"}}/>, title: "All Invoice List", onClick: () => {
                        }
                    },
                ]}
                onSearch={(value) => {
                    setSearchQuery(value);
                    setPage(1);
                }}
            />


            <div className="flex justify-center mt-8">
                <div className="w-full max-w-6xl md:overflow-x-auto">
                    <table className="w-full bg-white shadow-md rounded-lg overflow-hidden">
                        <thead
                            className="bg-gradient-to-r text-left from-buttonColor-shade4 to-marginColor-shade9 text-white">
                        <tr>
                            <th className="px-4 py-2 text-md font-medium rounded-tl-lg">Id Order</th>
                            <th className="px-4 py-2 text-md font-medium">User</th>
                            <th className="px-4 py-2 text-md font-medium">Amount Paid</th>
                            <th className="px-4 py-2 text-md font-medium">Status</th>
                            <th className="px-4 py-2 text-md font-medium rounded-tr-lg">Action</th>
                        </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                        {loading ?
                            <tr>
                                <td className="px-4 py-3 text-center" colSpan="5">
                                    <Loading/>
                                </td>
                            </tr>
                            :
                            invoice.length > 0 ?
                                invoice.map((item) =>
                                    <tr key={item._id}>
                                        <td className="px-4 py-3 text-md font-medium"># {item._id.slice(0, 5) || "-"}</td>
                                        <td className="px-4 py-3 text-md font-medium">{item.user_info?.userName}</td>
                                        <td className={`px-4 py-3`}>
                                            € {item.totalAmount}
                                        </td>
                                        <td className={`px-4 py-4`}>
                                        <span className={`px-2 hover:cursor-pointer py-1 rounded-full text-xs font-medium 
                                            ${item.isDeleted ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
                                            {item.isDeleted ? 'Deleted' : 'Active'}
                                        </span>
                                        </td>
                                        <td className="px-4 py-3 text-md font-medium">
                                            <button
                                                className="text-blue-500 hover:text-blue-700 font-medium mr-4"
                                                onClick={() => navigate(`/invoice/details/${item._id}`)}
                                            >
                                                See More
                                            </button>
                                        </td>
                                    </tr>
                                )
                                :
                                <tr>
                                    <td className="px-4 py-3 text-center" colSpan="5">Invoice not found!</td>
                                </tr>
                        }
                        </tbody>
                    </table>

                    {/* Pagination */}
                    <div className="flex justify-center items-center mt-6 space-x-2">
                        <button
                            disabled={page === 1}
                            onClick={() => setPage(prev => prev - 1)}
                            className={`px-3 py-1 rounded-md border ${page === 1 ? "text-gray-400 border-gray-200" : "text-blue-600 border-blue-400 hover:bg-blue-100"}`}
                        >
                            Prev
                        </button>
                        <span className="px-4">Page {page} of {totalPages}</span>
                        <button
                            disabled={page === totalPages}
                            onClick={() => setPage(prev => prev + 1)}
                            className={`px-3 py-1 rounded-md border ${page === totalPages ? "text-gray-400 border-gray-200" : "text-blue-600 border-blue-400 hover:bg-blue-100"}`}
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
